import { useMediaQuery } from "./use-media-query";

/**
 * Tailwind-aligned viewport hooks.
 *
 * Breakpoints match the Tailwind defaults used in tailwind.config.ts:
 *   - mobile : viewport width < 768px         (everything below `md`)
 *   - tablet : 768px ≤ width < 1024px         (`md` up to but excluding `lg`)
 *   - desktop: width ≥ 1024px                 (`lg` and above)
 *
 * All three are SSR-safe (see `useMediaQuery`) — they return `false` on the
 * server and the first client paint, then update on the next render after
 * mount. Use them for runtime branching: conditional rendering, swapping a
 * Dialog for a bottom sheet, or disabling a desktop-only interaction.
 *
 * For purely visual changes prefer Tailwind responsive classes (`md:`, `lg:`)
 * — they don't require JavaScript and don't re-render.
 */

export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767.99px)");
}

export function useIsTablet(): boolean {
  return useMediaQuery("(min-width: 768px) and (max-width: 1023.99px)");
}

export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 1024px)");
}
